import PropTypes from 'prop-types';

const IconButton = ({ label, icon, priority = 'tertiary', type = 'button', onClick = undefined, disabled = false, className = undefined }) => {
  return (
    <button type={type} className={`button  button--${priority}  button--icon`} onClick={onClick} disabled={disabled} data-icon={icon}>{label}</button>
  );
}

IconButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  priority: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  type: PropTypes.oneOf(['button', 'submit']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default IconButton;
